import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="text-center">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-blue-600">404</h1>
                    <div className="text-4xl font-semibold text-gray-800 mt-4">Page Not Found</div>
                </div>
                
                <p className="text-xl text-gray-600 mb-8">
                    Sorry, the page you are looking for doesn't exist.
                </p>
                
                <div className="space-x-4">
                    <Link
                        to="/home"
                        className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-md transition-colors shadow-sm"
                    >
                        Go to Home Page
                    </Link>
                    <Link
                        to="/"
                        className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-md transition-colors shadow-sm"
                    >
                        Go to Welcome Page
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
